export default __webpack_public_path__ + "static/media/Hospital.74373089.png";